import { createRouter, createWebHistory } from 'vue-router'

import Home from '@/views/Home/index.vue'
import PrivacyPolicy from '@/views/PrivacyPolicy.vue'
import Registered from '@/views/Registered.vue'
import NotFound from '@/views/NotFound.vue'
import PhoneConfirmBlock from '@/views/PhoneConfirmBlock.vue'

const routes = [
  { path: '/', component: Home },
  { path: '/privacy-policy', component: PrivacyPolicy },
  { path: '/registered', component: Registered },
  { path: '/:pathMatch(.*)*', component: NotFound },
  { path: '/confirm-phone', component: PhoneConfirmBlock, meta: { noBackground: true } },
]

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: () => ({ top: 0 }),
  routes,
})

export default router
